// extracted by mini-css-extract-plugin
export default {"title":"Ed0VIVfiluwPpiyYNw36","text":"gnfAKa6ZvGtXxjU4o3XC"};